export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '92437a9', dateTime: 1769810536791 };